// ═══════════════════════════════════════════════════════════════
// SIMPLE MARKDOWN → HTML RENDERER
// Handles **bold**, *italic*, lists, tables, code, hr
// ═══════════════════════════════════════════════════════════════

export function renderMarkdown(text) {
  if (!text) return '';
  
  let html = text
    // Escape HTML
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Bold
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    // Italic
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    // Inline code
    .replace(/`(.*?)`/g, '<code>$1</code>')
    // HR
    .replace(/^---$/gm, '<hr/>')
    // Headers (h1-h4)
    .replace(/^#### (.*$)/gm, '<strong>$1</strong>')
    .replace(/^### (.*$)/gm, '<strong>$1</strong>')
    .replace(/^## (.*$)/gm, '<strong>$1</strong>')
    .replace(/^# (.*$)/gm, '<strong>$1</strong>');

  // Simple table support
  if (html.includes('|')) {
    const lines = html.split('\n');
    let inTable = false;
    let tableHtml = '';
    const result = [];

    lines.forEach((line, i) => {
      const trimmed = line.trim();
      if (trimmed.startsWith('|') && trimmed.endsWith('|')) {
        if (!inTable) {
          inTable = true;
          tableHtml = '<table>';
        }
        // Skip separator row
        if (trimmed.replace(/[|\-\s:]/g, '') === '') return;
        
        const cells = trimmed.split('|').filter(c => c.trim() !== '');
        const isHeader = !inTable || (i > 0 && lines[i+1]?.trim().replace(/[|\-\s:]/g, '') === '');
        const tag = tableHtml === '<table>' ? 'th' : 'td';
        tableHtml += '<tr>' + cells.map(c => `<${tag}>${c.trim()}</${tag}>`).join('') + '</tr>';
      } else {
        if (inTable) {
          tableHtml += '</table>';
          result.push(tableHtml);
          tableHtml = '';
          inTable = false;
        }
        result.push(line);
      }
    });

    if (inTable) {
      tableHtml += '</table>';
      result.push(tableHtml);
    }

    html = result.join('\n');
  }

  // Unordered lists
  html = html.replace(/^- (.*$)/gm, '<li>$1</li>');
  html = html.replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>');

  // Ordered lists  
  html = html.replace(/^\d+\. (.*$)/gm, '<li>$1</li>');

  // Paragraphs (double newline)
  html = html.replace(/\n\n/g, '</p><p>');
  html = html.replace(/\n/g, '<br/>');
  html = '<p>' + html + '</p>';
  
  // Clean empty paragraphs
  html = html.replace(/<p>\s*<\/p>/g, '');
  html = html.replace(/<p><br\/>/g, '<p>');

  return html;
}
